import resources from './base';

export default resources('profile');



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/resources/user.js